import { isFeatureEnabled } from './featureFlags';

/** Breakpoint-keyed max height (e.g. `{ xs, sm, md }`), as accepted by MUI's `sx`. */
type ResponsiveHeight = { [breakpoint: string]: number };

export interface BrandLogo {
  src: string;
  alt: string;
  /** Max height on the home hero — tuned per logo since each has a different aspect ratio. */
  heroMaxHeight: ResponsiveHeight;
}

const COMMONLY_LOGO: BrandLogo = {
  src: '/Commonly Logo.png',
  alt: 'Commonly',
  heroMaxHeight: { xs: 140, sm: 180, md: 220 },
};

const COPLAN_LOGO: BrandLogo = {
  src: '/CoPlan Logo.png',
  alt: 'CoPlan',
  heroMaxHeight: { xs: 70, sm: 90, md: 100 },
};

/** The active brand logo, switchable via the `useCommonlyLogo` feature flag. */
export const brandLogo: BrandLogo = isFeatureEnabled('useCommonlyLogo')
  ? COMMONLY_LOGO
  : COPLAN_LOGO;
